import React, { useCallback } from "react";
import {
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  BarChart,
  Bar,
  Cell,
} from "recharts";
import moment from "moment";

const NoOfEmptySeatChart = ({ data, title, datakey, conditions }) => {
  const fillBar = useCallback(
    (value, max) => {
      if (
        value / max >= conditions["Good"]["Min"] &&
        value / max <= conditions["Good"]["Max"]
      ) {
        return "lawngreen";
      } else if (
        value / max >= conditions["Moderate"]["Min"] &&
        value / max <= conditions["Moderate"]["Max"]
      ) {
        return "#ffff00";
      } else if (
        value / max >= conditions["Poor"]["Min"] ||
        value / max <= conditions["Poor"]["Max"]
      ) {
        return "#f00";
      } else return "";
    },
    [conditions]
  );

  return (
    <>
      {data && data.length && (
        <ResponsiveContainer className="mt-4" minHeight={"100%"}>
          <BarChart
            data={data}
            height="100%"
            width="100%"
            margin={{ bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="8 8" />
            <XAxis
              dataKey="enqueuedTime_Stamp"
              tickFormatter={(unixTime) => moment(unixTime).format("HH:mm Do")}
              tick={{
                stroke: "#f3f3f3",
                fill: "#f3f3f3",
                strokeWidth: 0.5,
              }}
            />
            <YAxis
              tick={{
                stroke: "#f3f3f3",
                fill: "#f3f3f3",
                strokeWidth: 0.5,
              }}
            />
            <Tooltip
              wrapperClassName="navbar-bg"
              labelFormatter={(value) => {
                return `label: ${moment(value).format("HH:mm Do")}`;
              }}
            />
            <Legend
              verticalAlign="top"
              payload={[
                {
                  value: title,
                  type: "line",
                  id: "ID01",
                  color: "#c9e9f4",
                },
              ]}
            />
            <Bar dataKey={datakey} stroke="#c9e9f4" fill="#c9e9f4">
              {data?.map((entity, index) => {
                let color = fillBar(entity[datakey], entity["max"]);
                return <Cell fill={'#c9e9f4'} stroke={'#c9e9f4'} />;
              })}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </>
  );
};

export default NoOfEmptySeatChart;
